<router-outlet></router-outlet>

<arm-loader></arm-loader>
